<template>
  <div class="pushInto">
    <new-task-modal
      class="import-modal"
      :newModalVisible="importModal"
      :closeonclickmodal="closeonclickmodal"
      @closeNewTask="closeImport"
      @cancelEvent="closeAll"
      @addNewTask="nextStep"
      :isChangelastStep="true"
      agreeBtn="下一步"
      modalTitle="批量导入"
    >
      <div slot="content" style="text-align: left">
        <el-form
          :model="ruleFormImport"
          :rules="rulesImport"
          ref="ruleForm"
          label-width="86px"
          @validate="validateValue"
          :show-message="false"
        >
          <el-form-item label="模板下载">
            <el-button
              @click="downloadExcel(downloadURL)"
              class="import-btn"
              type="default"
              icon="el-icon-download"
            >模板下载</el-button>
            <div class="import-upload-tip">请根据模板格式上传数据文件</div>
          </el-form-item>
          <el-form-item label="上传文件" prop="isfile">
            <el-upload
              v-model="ruleFormImport.isfile"
              ref="upload"
              class="import-upload-file"
              accept=".xls, .xlsx"
              action="noUse"
              :data="uplodeDate"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :on-error="handleError"
              :before-remove="beforeRemove"
              :http-request="uploadSectionFile"
              multiple
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="ruleFormImport.fileList"
            >
              <el-button class="import-btn" type="default" icon="el-icon-upload2">文件上传</el-button>
              <div slot="tip" class="import-upload-tip">5M以内，支持扩展名.xls、.xlsx</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="标题行" prop="jbDesc">
            <el-input class="import-input" placeholder="请输入" v-model.trim="ruleFormImport.jbDesc"></el-input>
            <div class="import-upload-tip">默认从标题行下一条数据开始导入</div>
          </el-form-item>
          <el-form-item label="重复规则" prop="gzRadio">
            <el-radio-group
              v-model="ruleFormImport.gzRadio"
              class="import-radio"
              @change="chickCF(ruleFormImport.gzRadio)"
            >
              <el-radio :label="1">覆盖重复数据</el-radio>
              <el-radio :label="2">跳开重复数据</el-radio>
              <el-radio v-if="isJC" :label="3">允许重复数据</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="isJC && ruleFormImport.gzRadio !== 3"
            label="检查字段"
            class="import-group"
            prop="fieldGroup"
          >
            <el-checkbox-group v-model="ruleFormImport.fieldGroup" @change="changeJC">
              <el-checkbox
                v-for="(item, index) in fieldArr"
                :label="item.fieldName"
                :key="index"
                :disabled="item.isKey==1"
              >{{item.fieldNote.length > 5 ? item.fieldNote.slice(0, 5) + '...' : item.fieldNote}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <div
            v-if="ruleFormImport.gzRadio == 3 && isOnly !==''"
            class="push-notice"
          >主键字段“{{isOnly}}”，不可重复，其余字段具体内容均可重复</div>
        </el-form>
      </div>
    </new-task-modal>
    <new-task-modal
      class="detail-modal new-transfer-modal push-transferBody"
      :closeonclickmodal="closeonclickmodal"
      :newModalVisible="detailModal"
      @closeNewTask="closeDetail"
      @addNewTask="agreeDetail"
      @cancelEvent="closeAll"
      :isChangelastStep="true"
      :isLast="haveLast"
      agreeBtn="下一步"
      modalTitle="批量导入"
      @LastStep="LastTask"
    >
      <div slot="content">
        <new-transfer
          :isClose="isClose"
          :systematicRadio="systematicList"
          :excelRadio="excelList"
          :relationCheckbox="relationList"
        ></new-transfer>
      </div>
    </new-task-modal>
    <new-task-modal
      class="output-modal"
      :closeonclickmodal="closeonclickmodal"
      :newModalVisible="outputModal"
      @addNewTask="isdaoru"
      @closeNewTask="closeOutPut"
      @cancelEvent="closeAll"
      :isChangelastStep="true"
      agreeBtn="确定导入"
      modalTitle="批量导入"
      :isLast="haveLast"
      @LastStep="LastTask2"
    >
      <div slot="content" style="text-align: left">
        <div class="jichu-title">基础信息设置</div>
        <el-form
          :model="ruleFormOutPut"
          :rules="rulesOutPut"
          ref="ruleFormOut"
          label-width="86px"
          @validate="validateValue"
          :show-message="false"
        >
          <el-form-item label="标题行" prop="jbDesc">
            <el-input class="output-input" placeholder="请输入" v-model="ruleFormOutPut.jbDesc"></el-input>
          </el-form-item>
          <el-form-item label="重复规则" prop="gzRadio">
            <el-radio-group v-model="ruleFormOutPut.gzRadio" class="output-radio">
              <el-radio :label="1">覆盖重复数据</el-radio>
              <el-radio :label="2">跳过重复数据</el-radio>
              <el-radio v-if="isJC" :label="3">允许重复数据</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="isJC && ruleFormOutPut.gzRadio !== 3"
            label="检查字段"
            class="import-group"
            prop="fieldGroup"
          >
            <el-checkbox-group v-model="ruleFormOutPut.fieldGroup" @change="changeJC">
              <el-checkbox
                v-for="(item, index) in fieldArr"
                :label="item.fieldName"
                :key="index"
                :disabled="item.isKey==1"
              >{{item.fieldNote.length > 5 ? item.fieldNote.slice(0, 5) + '...' : item.fieldNote}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="ziduan">
            <div>
              <div class="jichu-title" style="margin-bottom: 10px;">字段映射</div>
              <new-transfer
                :isClose="isClose"
                :systematicRadio="systematicList"
                :excelRadio="excelList"
                :relationCheckbox="relationList"
              ></new-transfer>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </new-task-modal>
    <new-task-modal
      class="output-modal"
      :closeonclickmodal="closeonclickmodal"
      :newModalVisible="daoruGuoCModal"
      @addNewTask="daoruGuoCModal = false"
      @closeNewTask="isdaoruGuoC"
      @cancelEvent="closeAll"
      :isOneBtn="OnlyBtn"
      :isChangelastStep="true"
      :isDisabled="guanbiDisabled"
      agreeBtn="关闭"
      modalTitle="批量导入"
    >
      <div slot="content" style="text-align: left">
        <div class="daoru-addnew">
          <span>已新增 :</span>
          <span v-if="DaoruSuccese.newInsertNum == '导入中'">{{DaoruSuccese.newInsertNum}}</span>
          <span v-if="DaoruSuccese.newInsertNum >= 0">{{DaoruSuccese.newInsertNum}}条</span>
        </div>
        <div class="daoru-addnew">
          <span>已覆盖更新 :</span>
          <span v-if="DaoruSuccese.updateNum == '导入中'">{{DaoruSuccese.updateNum}}</span>
          <span v-if="DaoruSuccese.updateNum >= 0">{{DaoruSuccese.updateNum}}条</span>
        </div>
        <div class="daoru-addnew">
          <span>错误 :</span>
          <span v-if="DaoruSuccese.failNum == '导入中'">{{DaoruSuccese.failNum}}</span>
          <span v-if="DaoruSuccese.failNum >= 0">{{DaoruSuccese.failNum}}条</span>
          <span
            v-if="DaoruSuccese.failNum > 0"
            style="color:#2D8CF0;cursor: pointer;"
            @click="upFail"
          >点击下载错误数据</span>
        </div>
        <div class="daoru-addnew">
          <span>耗时 :</span>
          <span v-if="DaoruSuccese.Time == '导入中'">{{DaoruSuccese.Time}}</span>
          <span v-if="DaoruSuccese.Time >= 0">{{DaoruSuccese.Time}}秒</span>
        </div>
        <div class="daoru-addnew">
          <el-progress :percentage="percenNum"></el-progress>
        </div>
      </div>
    </new-task-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { selectXiaoqu, daoruDown, uploadFile } from "@/api/Daoru/daoru";
export default {
  props: {
    // 导入弹窗
    importModal: {
      type: Boolean,
      default: false
    },
    //上传文件接口链接
    actionURL: {
      type: String
    },
    //上传文件所带的参数
    actionUplodeDate: {
      type: Object,
      default: null
    },
    //下载模板接口链接
    downloadURL: {
      type: String
    },
    //下载模板是否带参数
    isDownloadCS: {
      type: Boolean,
      default: false
    },
    //下载模板所带参数
    isBid: {
      type: String
    },
    //获取关系列表接口链接
    relationURL: {
      type: String
    },
    //确定导入接口链接
    DaoruURL: {
      type: String
    },
    //获取导入状况接口链接
    IngURL: {
      type: String
    },
    //下载导入错误数据接口链接
    upFailURL: {
      type: String
    },
    //是否有检查字段
    isJC: {
      type: Boolean,
      default: false
    },
    //获取检查字段接口
    inspectionsURL: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  data () {
    return {
      daoruOnlykey: "", //导入的唯一key值
      closeonclickmodal: false, //是否开启点击空白处关闭弹窗
      countNum: 1, //用于显示第一个错误
      fieldArr: [], //检查字段名列表
      ruleFormImport: {
        jbDesc: "1",
        fileList: [], // 文件列表
        isfile: "",
        gzRadio: 1, // 重复规则
        fieldGroup: [] // 检查字段
      },
      rulesImport: {
        jbDesc: [{ required: true, message: "请输入标题行", trigger: "blur" }],
        isfile: [{ required: true, message: "请上传文件", trigger: "change" }],
        gzRadio: [
          { required: true, message: "请选择重复规则", trigger: "change" }
        ],
        fieldGroup: [
          { required: true, message: "请选择检查字段", trigger: "change" }
        ]
      },
      detailModal: false, // 字段匹配弹窗
      systematicList: [], //系统字段列表
      excelList: [], //excel表头列表
      relationList: [], //关系列表
      haveLast: true, //显示上一步按钮
      outputModal: false, // 导入最后数据确定弹窗
      ruleFormOutPut: {
        jbDesc: "",
        gzRadio: "", // 重复规则
        fieldGroup: []
      },
      rulesOutPut: {
        jbDesc: [{ required: true, message: "请输入标题行", trigger: "blur" }],
        gzRadio: [
          { required: true, message: "请选择重复规则", trigger: "change" }
        ],
        fieldGroup: [
          { required: true, message: "out请选择检查字段", trigger: "change" }
        ]
      },
      uplodeDate: {
        //上传文件带的参数
        tenantId: this.$store.state.user.tenantId
      },
      daoruGuoCModal: false, //导入过程弹窗
      OnlyBtn: true, //导入过程弹框只有一个按钮
      guanbiDisabled: true, //导入过程弹框关闭按钮
      daoruTimer: null, //导入过程定时器
      IsDaoruTimes: 0, //导入过程计时
      percenNum: 0, //进度条进度数字
      DaoruSuccese: {
        errorData: [], //错误数据  暂存前端 下载错误数据时返回
        failNum: "导入中", //失败数量
        newInsertNum: "导入中", //新增数量
        successNum: 1, //成功数量
        updateNum: "导入中", //覆盖数量
        Time: "导入中" //耗时
      }, //导入成功后的数据列表
      isOnly: "", //有检查字段显示主键
      isTS: "导入未完成", //导入弹框提示文字
      uploadFilter: ['.xls', '.xlsx'],
      isClose: true
    };
  },
  watch: {
    importModal: function () {
      if (this.importModal) {
        this.isClose = false
        if (this.actionUplodeDate !== null) {
          this.uplodeDate = this.actionUplodeDate;
          this.inspectionsSelect();
        }
      } else {
        this.isClose = true
      }
      // console.log(this.isClose)
      console.log("检测到改变", this.uplodeDate);
    }
  },
  methods: {
    closeAll () {
      // debugger

      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
      // this.$refs.ruleFormOut.resetFields();
      // this.$nextTick(() => {
      //   this.$refs.ruleForm.resetFields();
      //   this.$refs.ruleFormOut.resetFields();
      // });
      this.$refs.upload && this.$refs.upload.clearFiles();
      this.ruleFormImport.fieldGroup = [];
      this.ruleFormOutPut.fieldGroup = [];
      this.systematicList = [];
      this.excelList = [];
      this.relationList = [];
      this.fieldArr = [];
      this.isOnly = "";
      this.$emit("closeNewTask");
      this.detailModal = false;
      this.outputModal = false;
      clearInterval(this.daoruTimer);
      this.daoruTimer = null;
      // this.$refs.ruleForm.resetFields();
      // this.$refs.upload.clearFiles();
      this.systematicList = [];
      this.excelList = [];
      this.relationList = [];
      this.$refs.ruleFormOut && this.$refs.ruleFormOut.resetFields();
      this.fieldArr = [];
      this.isOnly = "";
      this.DaoruSuccese = {
        errorData: [], //错误数据  暂存前端 下载错误数据时返回
        failNum: "导入中", //失败数量
        newInsertNum: "导入中", //新增数量
        successNum: 1, //成功数量
        updateNum: "导入中", //覆盖数量
        Time: "导入中" //耗时
      };
      this.percenNum = 0;
      this.daoruGuoCModal = false;
      //开启定时器
      // this.getTime();
    },
    // 验证格式
    filterFileRes (testSuffix, uploadFilter) {
      let matchingCount = false
      uploadFilter.forEach(element => {
        // console.log(element)
        if (element === testSuffix) {
          matchingCount = true
        }
      })
      return matchingCount
    },
    //检查字段勾选时
    changeJC (val) {
      console.log("kankan检查字段", val);
    },
    // 上传失败
    handleError (err) {
      console.log(err)
      this.$message.error("只支持文件扩展名.xls、.xlsx");
    },
    uploadSectionFile (params) {
      console.log(params)
      const file = params.file
      const isLt5M = file.size / 1024 / 1024 < 5;
      let testSuffix = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      // console.log(testSuffix)
      let res = this.filterFileRes(testSuffix, this.uploadFilter)
      if (!res) {
        this.$message.error('上传文件格式错误')
        return (this.ruleFormImport.fileList = []);
      }
      if (!isLt5M) {
        this.$message.error("上传文件大小不得大于5M");
        return (this.ruleFormImport.fileList = []);
      }
      const form = new FormData();
      // 文件对象
      form.append("file", file);
      if (this.actionUplodeDate !== null) {
        form.append("tenantId", this.userInfo.tenant_id);
        console.log("id", this.uplodeDate.id);
        form.append("id", this.uplodeDate.id);
      } else {
        form.append("tenantId", this.userInfo.tenant_id);
      }
      uploadFile(this.actionURL, form)
        .then(res => {
          console.log(res, '上传结果')
          const code = res && parseInt(res.status, 10);
          if (code === 200) {
            this.ruleFormImport.isfile = "1";
          } else {
            this.ruleFormImport.fileList = [];
          }
        })
        .catch(err => {
          this.ruleFormImport.fileList = [];
          this.$message.error(err);
        });
    },
    //表单验证规则
    validateValue (prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //提交表单
    commn (formName) {
      this.countNum = 0;
      console.log("commnnnnn", this.ruleFormImport.fileList);
      this.$nextTick(() => {
        this.$refs[formName].validate(valid => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            if (formName == "ruleForm") {
              this.detailModal = true;
              return this.selecTrelationList();
            }
            if (formName == "ruleFormOut") {
              return this.daoru();
            }
          } else {
            return false;
          }
        });
      });
    },
    // 取消导入
    closeImport () {
      this.$refs.ruleForm.resetFields();
      // this.$refs.ruleFormOut.resetFields();
      // this.$nextTick(() => {
      //   this.$refs.ruleForm.resetFields();
      //   this.$refs.ruleFormOut.resetFields();
      // });
      this.$refs.upload.clearFiles();
      this.ruleFormImport.fieldGroup = [];
      this.ruleFormOutPut.fieldGroup = [];
      this.systematicList = [];
      this.excelList = [];
      this.relationList = [];
      this.fieldArr = [];
      this.isOnly = "";
      this.$emit("closeNewTask");
      console.log("取消导入", this.fieldArr);
    },
    // 下一步
    nextStep () {
      // this.$emit('closeNewTask');
      // this.detailModal = true;
      this.commn("ruleForm");
      // this.selecTrelationList();
    },
    //字段映射上一步
    LastTask () {
      this.systematicList = [];
      this.excelList = [];
      this.relationList = [];
      this.detailModal = false;
    },
    // 导入最后数据确定上一步
    LastTask2 () {
      this.outputModal = false;
    },
    //导入    点击文件列表中已上传的文件时的钩子
    handlePreview (file) {
      console.log(file);
    },
    //导入  文件列表移除文件时的钩子
    handleRemove (file, fileList) {
      console.log(file, fileList);
    },
    //导入   删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止删除。
    beforeRemove (file, fileList) {
      console.log(fileList);
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSuccess () {
      this.ruleFormImport.isfile = "1";
    },
    //导入   文件超出个数限制时的钩子
    handleExceed (files) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
        files.length
        } 个文件，请删除原有上传文件后再上传新的文件。`
      );
    },
    //匹配字段
    // 关闭字段匹配
    closeDetail () {
      // this.$refs.ruleForm.resetFields();
      // this.$refs.ruleFormOut.resetFields();
      // this.$refs.upload.clearFiles();
      // this.ruleFormImport.fieldGroup = [];
      // this.ruleFormOutPut.fieldGroup = [];
      // this.systematicList = [];
      // this.excelList = [];
      // this.relationList = [];
      // this.fieldArr = [];
      // this.isOnly = "";
      // this.$emit("closeNewTask");
      this.detailModal = false;
      // console.log("取消导入", this.fieldArr);
      this.inspectionsSelect()
    },
    // 下一步字段匹配
    agreeDetail () {
      var isNOTGO = false;
      this.systematicList.forEach(sys => {
        if (sys.is_must == 1) {
          isNOTGO = true;
        }
      });
      if (isNOTGO) {
        this.$message.error("请匹配所有系统必填字段");
      } else {
        this.outputModal = true;
        this.ruleFormOutPut = this.ruleFormImport;
      }
    },
    // 关闭 导入最后数据确定
    closeOutPut () {
      // this.$refs.ruleForm.resetFields();
      // this.$refs.ruleFormOut.resetFields();
      // this.ruleFormImport.fieldGroup = [];
      // this.ruleFormOutPut.fieldGroup = [];
      // this.$refs.upload.clearFiles();
      // this.systematicList = [];
      // this.excelList = [];
      // this.relationList = [];
      // this.fieldArr = [];
      // this.isOnly = "";
      // this.$emit("closeNewTask");
      // this.detailModal = false;
      this.outputModal = false;
      console.log("取消导入", this.fieldArr);
    },
    //确定导入
    isdaoru () {
      var isNOTGO = false;
      this.systematicList.forEach(sys => {
        if (sys.is_must == 1) {
          isNOTGO = true;
        }
      });
      if (isNOTGO) {
        this.$message.error("请匹配所有系统必填字段");
      } else {
        this.commn("ruleFormOut");
      }
    },
    daoru () {
      try {
        const url = this.DaoruURL;
        console.log("urlllll", url);
        let params = {};
        let isCheckField = "";
        if (this.actionUplodeDate !== null) {
          isCheckField = this.ruleFormOutPut.fieldGroup.join(",");
          console.log("看看检查字段", isCheckField);
          params = {
            tenantId: this.userInfo.tenant_id, //租户id
            headerLine: this.ruleFormOutPut.jbDesc, //标题行  默认为1
            ruleNum: this.ruleFormOutPut.gzRadio, //重复规则 1 覆盖重复数据  2 跳过重复数据
            checkField: isCheckField, //检查字段 英文 多个逗号隔开 例如："campus_id,address,campus_name"
            id: this.uplodeDate.id, //表的id
            matchFieldList: this.relationList
          };
        } else {
          params = {
            tenantId: this.userInfo.tenant_id, //租户id
            headerLine: this.ruleFormOutPut.jbDesc, //标题行  默认为1
            ruleNum: this.ruleFormOutPut.gzRadio, //重复规则 1 覆盖重复数据  2 跳过重复数据
            matchFieldList: this.relationList
          };
        }
        console.log("这是检查字段的isCheckField", isCheckField);
        selectXiaoqu(url, params).then(res => {
          const data = res.data;
          console.log("这是关系列表获取接口", data);
          if (data.status === 1000) {
            this.daoruOnlykey = data.result;
            this.$emit("closeNewTask");
            this.detailModal = false;
            this.outputModal = false;
            this.daoruGuoCModal = true;
            //清空定时器
            clearInterval(this.daoruTimer);
            this.daoruTimer = null;
            this.IsDaoruTimes = 0;
            //开启定时器
            this.getTime();
          } else if (data.status === 1002) {
            this.$message.error(data.msg);
            this.closeOutPut();
            //清空定时器
            clearInterval(this.daoruTimer);
            this.daoruTimer = null;
            this.IsDaoruTimes = 0;
          } else {
            this.$message.error(data.msg);
            this.closeOutPut();
            //清空定时器
            clearInterval(this.daoruTimer);
            this.daoruTimer = null;
            this.IsDaoruTimes = 0;
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //下载模板
    downloadExcel (val) {
      console.log("valllllll", val);
      if (this.isDownloadCS) {
        try {
          const url = val;
          console.log("urlllll", url);
          const params = {
            id: this.isBid, //表id
            tenantId: this.userInfo.tenant_id
          };
          console.log("params", params);
          this.$downLoadFile(url, params);
        } catch (err) {
          console.log(err);
        }
      } else {
        console.log("valllllll", val);
        this.$downLoadFile(val);
      }
    },
    //获取字段匹配
    selecTrelationList () {
      try {
        const url = this.relationURL;
        console.log("urlllll", url);
        let params = {};
        if (this.actionUplodeDate !== null) {
          params = {
            tenantId: this.userInfo.tenant_id,
            id: this.uplodeDate.id
          };
        } else {
          params = {
            tenantId: this.userInfo.tenant_id
          };
        }
        selectXiaoqu(url, params).then(res => {
          const data = res.data;
          console.log("这是关系列表获取接口", data);
          if (data.status === 1000) {
            this.relationList = data.result.matchFieldList;
            //遍历对比已匹配的系统字段，并保留未匹配的
            var sysisNot = false;
            data.result.dbFieldList.forEach(sys => {
              this.relationList.forEach(rel => {
                if (sys.column == rel.column) {
                  sysisNot = true;
                }
              });
              if (!sysisNot) {
                console.log("inNottttttt", sysisNot);
                this.systematicList.push(sys);
              } else {
                sysisNot = false;
              }
            });
            console.log("systematicList", this.systematicList);
            //遍历对比已匹配的excel表头，并保留未匹配的
            var excisNot = false;
            data.result.excelField.forEach(exc => {
              this.relationList.forEach(rel => {
                if (exc == rel.configure) {
                  excisNot = true;
                }
              });
              if (!excisNot) {
                console.log("inNottttttt", excisNot);
                this.excelList.push(exc);
              } else {
                excisNot = false;
              }
            });
            console.log("excelList", this.excelList);
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //轮询状态请求查询导入状况
    daoruIng () {
      // debugger
      try {
        const url = this.IngURL;
        console.log("urlllll", url);
        let params = {};
        if (this.actionUplodeDate !== null) {
          params = {
            tenantId: this.userInfo.tenant_id,
            id: this.uplodeDate.id,
            key: this.daoruOnlykey
          };
        } else {
          params = {
            tenantId: this.userInfo.tenant_id,
            key: this.daoruOnlykey
          };
        }
        selectXiaoqu(url, params).then(res => {
          const data = res.data;
          console.log("这是轮询状态请求查询导入状况接口", data);
          // debugger
          if (data.status === 1000) {
            if (data.result == "" || data.result == null || data.result == "null") {
              if (this.percenNum < 90) {
                this.percenNum = this.percenNum + 10;
              } else {
                this.percenNum = 90;
              }
            } else {
              clearInterval(this.daoruTimer);
              this.daoruTimer = null;
              // this.percenNum = 100;
              // debugger
              this.DaoruSuccese = data.result;
              console.log("DaoruSuccese", this.DaoruSuccese);
              let IsTimes = "";
              IsTimes = this.IsDaoruTimes.toString();
              console.log("看看IsTimes", IsTimes);
              console.log("看看IsTimes的类型", typeof IsTimes);
              this.DaoruSuccese.Time = IsTimes;
              console.log(
                "看看DaoruSuccese.Time的类型",
                typeof this.DaoruSuccese.Time
              );
              console.log("DaoruSuccese.Time", this.DaoruSuccese.Time);
              this.IsDaoruTimes = 0;
              this.percenNum = 100;
              this.guanbiDisabled = false;
              this.isTS = "导入完成";
              if (this.isTS !== "导入完成") {
                this.$message.error(this.isTS);
              } else {
                this.$message.success(this.isTS);
              }
            }
          } else if (data.status === 1002) {
            clearInterval(this.daoruTimer);
            this.daoruTimer = null;
            this.isTS = "操作失败";
            if (this.isTS !== "导入完成") {
              this.$message.error(this.isTS);
            } else {
              this.$message.success(this.isTS);
            }
            this.isdaoruGuoC();
          } else {
            if (this.isTS !== "导入完成") {
              this.$message.error(this.isTS);
            } else {
              this.$message.success(this.isTS);
            }
            clearInterval(this.daoruTimer);
            this.daoruTimer = null;
            this.isTS = "操作失败";
            this.isdaoruGuoC();
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //查询导入状况定时器
    getTime () {
      this.daoruTimer = setInterval(() => {
        this.IsDaoruTimes = this.IsDaoruTimes + 3;
        this.daoruIng();
      }, 3000);
    },
    //下载错误数据
    upFail () {
      try {
        const url = this.upFailURL;
        console.log("urlllll", url);
        // const dat = {
        //   tenantId: this.userInfo.tenant_id
        // };
        let dat = {};
        if (this.actionUplodeDate !== null) {
          dat = {
            tenantId: this.userInfo.tenant_id,
            id: this.uplodeDate.id,
            errorKey: this.DaoruSuccese.errorKey //下载错误数据带的参数
          };
        } else {
          dat = {
            tenantId: this.userInfo.tenant_id,
            errorKey: this.DaoruSuccese.errorKey //下载错误数据带的参数
          };
        }
        daoruDown(url, dat).then(res => {
          const data = res;
          console.log(data);
          if (this.actionUplodeDate !== null) {
            window.open(
              url +
              "?tenantId=" +
              this.userInfo.tenant_id +
              "&id=" +
              this.uplodeDate.id +
              "&errorKey=" +
              this.DaoruSuccese.errorKey
            );
          } else {
            window.open(
              url +
              "?tenantId=" +
              this.userInfo.tenant_id +
              "&errorKey=" +
              this.DaoruSuccese.errorKey
            );
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //关闭导入过程弹框
    isdaoruGuoC () {
      console.log(1111111)
      clearInterval(this.daoruTimer);
      this.daoruTimer = null;
      this.$refs.ruleForm.resetFields();
      this.$refs.upload.clearFiles();
      this.systematicList = [];
      this.excelList = [];
      this.relationList = [];
      this.$refs.ruleFormOut.resetFields();
      this.fieldArr = [];
      this.isOnly = "";
      this.DaoruSuccese = {
        errorData: [], //错误数据  暂存前端 下载错误数据时返回
        failNum: "导入中", //失败数量
        newInsertNum: "导入中", //新增数量
        successNum: 1, //成功数量
        updateNum: "导入中", //覆盖数量
        Time: "导入中" //耗时
      };
      this.percenNum = 0;
      this.daoruGuoCModal = false;
      this.$emit("daoruSuccess");
    },
    //获取检查字段
    inspectionsSelect () {
      try {
        const url = this.inspectionsURL;
        console.log("urlllll", url);
        const params = {
          id: this.uplodeDate.id, //表id
          tenantId: this.userInfo.tenant_id //租户id
        };
        selectXiaoqu(url, params).then(res => {
          const data = res.data || {
            status: 1002
          };
          console.log("这是检查字段列表获取接口", data);
          if (data.status === 1000) {
            this.fieldArr = data.result;
            this.fieldArr.forEach(element => {
              if (element.isKey == 1) {
                this.ruleFormImport.fieldGroup.push(element.fieldName);
                console.log("获取检查字段", this.ruleFormImport.fieldGroup);
              }
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //有检查字段的情况下选择允许重复数据
    chickCF (val) {
      if (val == 3) {
        let arrJC = [];
        this.fieldArr.forEach(element => {
          if (element.isKey == 1) {
            arrJC.push(element.fieldNote);
          }
        });
        this.isOnly = arrJC.join("，");
      }
    }
  },
  mounted () {
    this.uplodeDate.tenantId = this.userInfo.tenant_id;
  }
};
</script>

<style lang="scss">
.pushInto {
  .new-transfer-modal {
    .el-dialog__body {
      height: 369px;
      overflow-y: hidden;
    }
  }
  .ziduan {
    .el-form-item__content {
      margin-left: 0px !important;
    }
  }
  .jichu-title {
    width: 72px;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFangSC;
    font-weight: 600;
    color: rgba(48, 66, 88, 1);
    line-height: 17px;
  }
  .daoru-addnew {
    height: 28px;
    line-height: 28px;
    margin-top: 16px;
    span {
      margin-right: 8px;
    }
  }
  .push-notice {
    // padding-top: 14px;
    padding-left: 84px;
    color: #aeaeb4;
    line-height: 28px;
    font-size: 12px;
  }
}
</style>
